import { EReservationAssetType } from './ReservationAssetsTypesList';

interface Props {
  value: EReservationAssetType;
  selected_value: EReservationAssetType;
  on_value_change: (value: EReservationAssetType) => void;
}

export function ReservationAseetsTypesListItem({ value, on_value_change, selected_value }: Props) {
  /*
   * EVENTS
   */

  function on_value_change_internal() {
    on_value_change(value);
  }

  /*
   * METHODS
   */

  /*
   * RENDERS
   */

  function render_assets_amount() {
    if (value === EReservationAssetType.BUNDLE) return null;

    return <div className="w-[25px] h-[25px] rounded-lg bg-component border border-component-border flex items-center justify-center">{5}</div>;
  }

  /*
   * HTML
   */

  return (
    <div
      onClick={on_value_change_internal}
      className={`flex text-page-foreground items-center hover:bg-component-item-selected h-[32px] px-4 rounded-lg
            ${value === selected_value ? 'bg-component-item-selected' : 'bg-component'}
            justify-between cursor-pointer `}
      key={value}
    >
      <span>{value}</span>

      {render_assets_amount()}
    </div>
  );
}
